export default __webpack_public_path__ + "static/media/check_hand.2dfd0fdb.svg";